import { PropsWithChildren, createContext, useCallback, useContext, useState } from 'react';

import NotesProps from '@/interfaces/notes';

interface NotesContextProps {
  selectedNote: NotesProps | null;
  setCurrentNote: (note: NotesProps) => void;
  clearCurrentNote: () => void;
}

const NotesContext = createContext<NotesContextProps>({} as NotesContextProps);

export function useNotes() {
  const context = useContext(NotesContext);

  if (!context) {
    throw new Error('useNotes must be used within a NotesProvider');
  }

  return context;
}

export const NotesContextProvider = ({ children }: PropsWithChildren) => {
  const [selectedNote, setSelectedNote] = useState<NotesProps | null>(null);

  const setCurrentNote = useCallback((note: NotesProps) => setSelectedNote(note), []);

  const clearCurrentNote = useCallback(() => setSelectedNote(null), []);

  return (
    <NotesContext.Provider value={{ selectedNote, setCurrentNote, clearCurrentNote }}>{children}</NotesContext.Provider>
  );
};
